export default (state = [], action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.parent_customer) {
        return payload.parent_customer;
      }
      return state;
    }
  }
};
